import React, { useCallback } from 'react'

import ProjectListItem from './ProjectListItem'
import { Project } from './types'

interface ProjectSwitchPanelProps {
  className?: string
  isProcessing?: boolean
  projects: Project[]
  handleProjectSelect: (projectId: string) => void
}

function ProjectSwitchPanel({
  className = '',
  isProcessing,
  projects,
  handleProjectSelect,
}: ProjectSwitchPanelProps) {
  const handleClickProject = useCallback(
    (projectId: string) => () => handleProjectSelect(projectId),
    []
  )

  return (
    <div
      className={`rounded-[20px] border border-solid border-white/15 bg-[#081C3499]/60 p-[8px] ${className}`}
    >
      <div className="flex h-full w-full flex-col gap-1">
        {projects.map((project) => (
          <ProjectListItem
            key={project.id}
            canonicalName={project.canonicalName}
            label={project.label}
            onClick={handleClickProject(project.id)}
            isProcessing={isProcessing}
          />
        ))}
      </div>
    </div>
  )
}

export default ProjectSwitchPanel
